import React from 'react'
import { PlusCircle } from '@phosphor-icons/react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import FormHeaderDetailActions from '../../../components/action_button/FormHeaderDetailActions'
import LoadingScreen from '../../../components/LoadingScreen'
import RbacUsersTable from '../../components/RbacUsersTable'
import { RBAC_ROLE_DETAIL_TEXTS } from '../shared/rbacRoleDetailConstants'

const usersEmptyState = {
  title: 'Este rol no tiene usuarios asignados',
  description: 'Agrega usuarios para que empiecen a usar los permisos configurados en este rol.'
}

export default function RbacRoleUsersTab({
  role,
  rows,
  loading,
  pagination,
  canManageUsers = false,
  isAdmin = false,
  actionMenuAnchorEl,
  actionMenuUser,
  onAddUsers,
  onUserRowClick,
  onOpenActionMenu,
  onCloseActionMenu,
  onActionMenuExited,
  onAssignAction,
  onViewAction,
  onPageChange,
  onRowsPerPageChange
}) {
  return (
    <div className="container-fluid px-0">
      <Box
        sx={{
          display: 'flex',
          alignItems: { xs: 'stretch', md: 'center' },
          justifyContent: 'space-between',
          gap: 2,
          flexWrap: 'wrap',
          mt: 3,
          mb: 2
        }}
      >
        <Typography sx={{ fontSize: 16, m: 0, lineHeight: 1.3 }}>
          Usuarios que tienen asignado este rol
        </Typography>

        {canManageUsers ? (
          <FormHeaderDetailActions
            showSecondary={false}
            primaryLabel="Agregar usuarios"
            primaryIcon={PlusCircle}
            iconSize={22}
            onPrimary={onAddUsers}
            stackOnMobile
          />
        ) : null}
      </Box>

      {loading ? <LoadingScreen text={RBAC_ROLE_DETAIL_TEXTS.loading} minHeight="360px" /> : null}

      <Box>
        {!loading ? (
          <RbacUsersTable
            loading={false}
            paginatedUsers={rows}
            pagination={pagination}
            isAdmin={isAdmin}
            actionMenuAnchorEl={actionMenuAnchorEl}
            actionMenuUser={actionMenuUser}
            onUserRowClick={onUserRowClick}
            onOpenActionMenu={onOpenActionMenu}
            onCloseActionMenu={onCloseActionMenu}
            onActionMenuExited={onActionMenuExited}
            onAssignAction={onAssignAction}
            onViewAction={onViewAction}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
            actionMode="role-users"
            canReassign={canManageUsers}
            fallbackRole={role}
            emptyState={usersEmptyState}
          />
        ) : null}
      </Box>
    </div>
  )
}
